import { OrderDirectionEnum } from "@admin_api/models/order-direction-enum";
import { getInitialLocalFilterDateRangeLastTwoWeeks, DateRange, Pager, FilterBase, createFilter } from "shared-lib";
import { PayPalEventDeliveryDto } from "@admin_api/models/pay-pal-event-delivery-dto";
import { PayPalEventDeliveryOrderByEnum } from "@admin_api/models/pay-pal-event-delivery-order-by-enum";
import { PayPalEventDeliveryStatusEnum } from "@admin_api/models/pay-pal-event-delivery-status-enum";

export class Sorting {
    orderBy: null | PayPalEventDeliveryOrderByEnum = PayPalEventDeliveryOrderByEnum.CreateTime;
    orderDirection: null | OrderDirectionEnum = OrderDirectionEnum.Desc;
}

export class Filter extends FilterBase<Filter> {
    // NOTE: Must set all params to null or undefined or a specific value (required for undo)

    // localDateInterval is relative to the local time zone (eg. see LocalTimePoint.timeZone)
    // (API endpoints require UTC time so this value will be shifted at send)
    localDateInterval?: DateRange = getInitialLocalFilterDateRangeLastTwoWeeks();
    startDate?: string = undefined;
    endDate?: string = undefined;

    eventType?: string = undefined;
    id?: string = undefined;
    status?: PayPalEventDeliveryStatusEnum = undefined;
}

export class PayPalEventsState {
    loading = false;
    error: Error = null;
    rows: Array<PayPalEventDeliveryDto> = [];
    sorting = new Sorting();
    pager = new Pager();
    filter = createFilter(Filter);
}
